//sticky filters script
if(window.location.href.includes('collection')){
    function checkForElement(selector, callback) {
        const maxDuration = 10000;
        const intervalDuration = 500;
        let elapsedTime = 0;
    
        const interval = setInterval(() => {
            const elem = document.querySelector(selector);
            if (elem) {
                clearInterval(interval);
                callback(elem);
            }
            elapsedTime += intervalDuration;
            if (elapsedTime >= maxDuration) {
                clearInterval(interval);
            }
        }, intervalDuration);
    }
    
    window.addEventListener('load', () => {
        checkForElement('.usf-facets__body', (facetsBodyElem) => {
            let hasIntersected = false; 
            const applyFacetsBodyStyle = (applyStyles) => {
                if (applyStyles) {
                    facetsBodyElem.parentNode.style.cssText = `
                        position: fixed;
                        z-index: 29;
                        top: 86px;
                        background-color: #fff;
                        width: 100%;
                        left: 0;
                        margin: 0;
                    `;
                } else {
                    facetsBodyElem.parentNode.style.cssText = '';
                }
            };
    
            if (window.matchMedia('(min-width: 750px)').matches) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !hasIntersected) {
                            hasIntersected = true;
                        }
                        if (hasIntersected) {
                            if (entry.boundingClientRect.top > 0) {
                                applyFacetsBodyStyle(false)
                            } else {
                                applyFacetsBodyStyle(true);
                            }
                        }
                    });
                }, { threshold: 0.3 });
    
                const filtersElem = document.querySelector('.collection .usf-sr-config');
                if (filtersElem) observer.observe(filtersElem);
            }
    
            window.addEventListener('resize', () => {
                if (window.matchMedia('(min-width: 750px)').matches) {
                } else {
                    applyFacetsBodyStyle(false);
                }
            });
        });
    
        checkForElement('.usf-sr-config__mobile-filters-wrapper', (stickyElem) => {
            const observeElem = document.querySelector('.usf-sr-config');
            let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let isElementSticky = false;
    
            if (window.innerWidth <= 749) {
                const observers = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            isElementSticky = !entry.isIntersecting;
                            adjustStickyElementStyle();
                        });
                    },
                    { threshold: 0 }
                );
                if (observeElem) observers.observe(observeElem);
    
                const adjustStickyElementStyle = () => {
                    let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    if (isElementSticky) {
                        if (currentScrollTop > lastScrollTop) {
                            stickyElem.style.cssText = `
                                position: fixed;
                                z-index: 99;
                                top: 0;
                                width: 100%;
                                background-color: #fff;
                                left: 0;
                            `;
                        } else {
                            stickyElem.style.cssText = `
                                position: fixed;
                                z-index: 99;
                                top: 60px;
                                width: 100%;
                                background-color: #fff;
                                left: 0;
                            `;
                        }
                    } else {
                        stickyElem.style.cssText = '';
                    }
                    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
                };
    
                window.addEventListener('scroll', adjustStickyElementStyle, false);
            }
        });
    });
    


}
